"use client";

import { useEffect, useState } from "react";

/** True when the primary input supports hover (mouse/trackpad), not touch-only. */
export function useHoverCapability() {
  const [canHover, setCanHover] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(hover: hover) and (pointer: fine)");

    const update = () => setCanHover(query.matches);
    update();

    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return canHover;
}
